import type {PaginationFilters} from '@cohort/merchants/hooks/filters/basePageFilters';
import {useBasePageFilters} from '@cohort/merchants/hooks/filters/basePageFilters';
import type {PerkAccessStatus} from '@cohort/shared/schema/common/perks';

export const statusFilter = ['used', 'unused'] as const;
export const sortFilter = ['availableSince', '-availableSince'] as const;

export type UserPerksFilters = {
  status: Array<PerkAccessStatus>;
  setStatus: (status: Array<PerkAccessStatus>) => void;
  sort: 'availableSince' | '-availableSince';
  setSort: (sort: 'availableSince' | '-availableSince') => void;
  reset: () => void;
};

export const useUserPerksFilters = (): PaginationFilters & UserPerksFilters =>
  useBasePageFilters<UserPerksFilters>(/^(\/test)?\/users\/.*\/perks$/u, set => ({
    status: [],
    setStatus: status => set({status}),
    sort: '-availableSince',
    setSort: sort => set({sort}),
    reset: () => set({status: [], sort: '-availableSince'}),
  }));
